import classNames from 'classnames';

import { useFlags } from '@hook/useFlags';
import { SchoolBanner } from '@components/SchoolBanner';

import s from './CatalogTopBannerContainer.sss';

type Props = {
  className?: string
};

export const CatalogTopBannerContainer: React.FC<Props> = ({
  className,
}) => {
  const { schoolSaleEnabled } = useFlags();

  if (schoolSaleEnabled) {
    return (
      <div className={classNames(s.root, className)}>
        <SchoolBanner page="catalog" />
      </div>
    );
  }

  return null;
};
